import img1 from "../../utils/img/img_MedicalSupport/s3/1.png";
import img2 from "../../utils/img/img_MedicalSupport/s3/image108.png";
import img3 from "../../utils/img/img_MedicalSupport/s3/image112.png";
import img4 from "../../utils/img/img_MedicalSupport/s3/image111.png";
import img5 from "../../utils/img/img_MedicalSupport/s3/image113.png";
import img6 from "../../utils/img/img_MedicalSupport/s3/image114.png";
import img7 from "../../utils/img/img_MedicalSupport/s3/7.png";
import img7_1 from "../../utils/img/img_MedicalSupport/s3/image116.png";
import img8 from "../../utils/img/img_MedicalSupport/s3/9.png";
import img8_1 from "../../utils/img/img_MedicalSupport/s3/image118.png";
import img9 from "../../utils/img/img_MedicalSupport/s3/11.png";
import img10 from "../../utils/img/img_MedicalSupport/s3/12.png";


const dataForBlock = [
    {
        "id": 0,
        "title": "Если пострадавший находится в сознании",
        "description": ["Его экстренное извлечение производится так: руки участника оказания первой помощи проводятся под подмышками пострадавшего, фиксируют его предплечье, после чего пострадавший извлекается наружу.",
            "После извлечения следует переместить пострадавшего на безопасное расстояние и в безопасное место"],
        "img": [img1]
    },
    {
        "id": 1,
        "title": "Перемещение пострадавшего в одиночку с поддержкой",
        "description": ["Используется для перемещения легкопострадавших лиц, находящихся в сознании"],
        "img": [img2]
    },
    {
        "id": 2,
        "title": "Перемещение пострадавшего в одиночку волоком",
        "description": ["Применяется для перемещения на близкое расстояние пострадавших, имеющих значительный вес. Нежелательно использовать у пострадавших с травмами нижних конечностей"],
        "img": [img3]
    },
    {
        "id": 3,
        "title": "Переноска пострадавшего в одиночку на спине",
        "description": ["Может использоваться для переноски пострадавших, имеющих небольшой вес. Не применяется для переноски пострадавших, находящихся без сознания"],
        "img": [img4]
    },
    {
        "id": 4,
        "title": "Переноска пострадавшего на руках",
        "description": ["Используется лицами, имеющими достаточную для применения этого способа физическую силу. Этим способом возможна переноска пострадавших, находящихся без сознания. Нежелательно переносить так пострадавших с подозрением на травму позвоночника"],
        "img": [img5]
    },
    {
        "id": 5,
        "title": "Переноска пострадавшего в одиночку на плече",
        "description": ["При переноске таким способом следует придерживать пострадавшего за руку. Этот способ не применяется при переноске пострадавших с травмами груди, живота и позвоночника"],
        "img": [img6]
    },
    {
        "id": 6,
        "title": "Переноска пострадавшего вдвоём на замке из четырёх рук",
        "description": ["Руки берутся таким образом, чтобы обхватить запястье другой руки и руки помощника. Фиксация кистей должна быть достаточно прочной, чтобы удержать пострадавшего"],
        "img": [img7 , img7_1]
    },
    {
        "id": 7,
        "title": "Переноска пострадавшего вдвоём на замке из четырёх рук",
        "description": ["Руки берутся таким образом, чтобы обхватить запястье другой руки и руки помощника. Фиксация кистей должна быть достаточно прочной, чтобы удержать пострадавшего"],
        "img": [img8 , img8_1]
    },
    {
        "id": 8,
        "title": "Переноска пострадавшего вдвоём за руки и ноги",
        "description": ["При переноске этим способом, один из участников оказания первой помощи держит пострадавшего за предплечье одной руки, просунув руки подмышки, а другой — под колени"],
        "img": [img9]
    },
    {
        "id": 9,
        "title": "Переноска пострадавшего с подозрением на травму позвоночника",
        "description": ["Для переноски пострадавшего с подозрением на травму позвоночника необходимо несколько человек, которые под руководством одного из участников оказания первой помощи поднимают и переносят пострадавшего. При переноске один из участников оказания первой помощи должен фиксировать голову и шею пострадавшего своими предплечьями. Более удобно и безопасно для пострадавшего с подозрением на травму позвоночника переносить его на твёрдой ровной поверхности (например, на щите).",
            "После извлечения пострадавшего и его переноски в безопасное место, оцените его состояние. Если состояние потерпевшего стабильное и не ухудшается (не теряют сознание, нет явных и открытых кровотечений и иных повреждений, требующих неотложной помощи, не двигайте его и контролируйте его состояние до приезда скорой, при необходимости укройте его одеждой или специальным теплосохрагяющим покрывалом.",
            "Если пострадавший без сознания.",
            "Проверьте наличие, реакцию зрачка на свет, дыхания, сердцебиения.",
            "При их отсутствии приступайте к извлечению пострадавшего и начинайте реанимационные мероприятия по системе ABC."],
        "img": [img10]
    },
    {
        "id": 10,
        "title": "При извлечении пострадавшего, находящегося без сознания или с подозрением на травму шейного отдела позвоночника",
        "description": ["Необходимо фиксировать ему голову и шею. При этом одна из рук участника оказания первой помощи фиксирует за нижнюю челюсть голову пострадавшего, а вторая держит его противоположное предплечье.",
            "После извлечения следует переместить пострадавшего на безопасное расстояние и в безопасное место.s"],
        "img": [img1]
    }
]

export {dataForBlock};